module.exports = __webpack_public_path__ + "static/Sean-Grove-1c6c286ea83694eb126b33f9d0f8e391.png";